import { connect } from 'react-redux'
import SaveSuccess from '../../components/Segment/SaveSuccess'
import {
	clearSegmentWithRules
} from '../../actions/SegmentList'

const mapStateToProps = (state) => {
	const { selected_segments, segment_name, save_segment_report_id } = state.segmentCreation;
	return {
		selected_segments,
		segment_name,
    save_segment_report_id
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		clearSegmentWithRules: () => {
			dispatch(clearSegmentWithRules());
		},
	}
}

const SegmentSaveSuccess = connect(
	mapStateToProps,
	mapDispatchToProps
)(SaveSuccess)

export default SegmentSaveSuccess


// WEBPACK FOOTER //
// ./src/containers/Segment/SegmentSaveSuccess.js